export type StaffType = 'LE' | 'GES';

export type StaffChannel = 'Directo' | 'API';

export type StaffSearchMode = 'RUT' | 'NAME';

export const TYPE_LABELS: Record<StaffType, { label: string; title: string }> = {
  LE: { label: 'Plan complementario', title: 'Staff Plan Complementario vigente' },
  GES: { label: 'GES', title: 'Staff GES vigente' },
};

export const CHANNEL_LABELS: Record<StaffChannel, string> = {
  Directo: 'Directo',
  API: 'API',
};

export interface StaffCatalogOption {
  id: number;
  label: string;
}

export const STAFF_BATCH_LIMIT_EXCEEDED_REASON = 'STAFF_BATCH_LIMIT_EXCEEDED';

export interface StaffBatchLimitExceededDetails {
  reason: typeof STAFF_BATCH_LIMIT_EXCEEDED_REASON;
  totalRecords?: number;
  maxRecords: number;
}
